import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

export const StarIcon = ({ width = 40, height = 40, ...props }: StarIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    {...props}
  >
    <path
      d='M20 0C20 11.0457 28.9543 20 40 20C28.9543 20 20 28.9543 20 40C20 28.9543 11.0457 20 0 20C11.0457 20 20 11.0457 20 0Z'
      fill='currentColor'
    />
  </svg>
);


